import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { HStack } from 'src/components/BasicComponents';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';

export const NoConfiguration: FC = () => {
  const event = useCurrentEvent();
  if (event == null) return <></>;

  return (
    <HStack align="center">
      <div style={{ width: '66%' }}>
        From which timekeeping system are you forwarding reads to Racemap?
        <br />
        Test beforehand the forwarding of reads and appropriate settings of the timing system.
        Monitor the timing data in the{' '}
        <Link to={`/admin/events/${event.id}/prediction/reads`}>Reads-</Link> and{' '}
        <Link to={`/admin/events/${event.id}/prediction/readers`}>Readers</Link> section of this
        dashboard.
      </div>
    </HStack>
  );
};
